module.exports = __webpack_public_path__ + "static/media/FederalElection2025LogoLarge.6d8a2faf.svg";